import React, { useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { useHistory } from 'react-router-dom';
import { Button } from 'primereact/button';
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const GanttChart = (props) => {
  const history = useHistory();
  const [tasks, setTasks] = useState();
  const [monthList, setMonthList] = useState();
  const [searchText, setSearchText] = useState('');
  const filterProjects = useStoreState((actions) => actions.projectModel.filterProjects);
  const subTaskProjectNameUser = useStoreState((actions) => actions.projectModel.subTaskProjectNameUser);
  const setSubTaskProjectNameUser = useStoreActions((actions) => actions.projectModel.setSubTaskProjectNameUser);
  const subTaskRedirectUser = useStoreState((actions) => actions.projectModel.subTaskRedirectUser);
  const setSubTaskRedirectUser = useStoreActions((actions) => actions.projectModel.setSubTaskRedirectUser);
  const fromDashboardUser = useStoreState((actions) => actions.projectModel.fromDashboardUser);
  const setFromDashboardUser = useStoreActions((actions) => actions.projectModel.setFromDashboardUser);

  const formatDate = (value) => {
    var date = value ? new Date(value) : null;
    return date?.toLocaleDateString('en-US', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  }
  useEffect(() => {
    // setSubTaskRedirect(null);
    // setSubTaskProjectName(null);
  },[]);


  // Generate month data
  const generateMonthData = (start, end) => {
    const months = [];
    const current = new Date(start.getFullYear(), start.getMonth(), 1);
    while (current <= end) {
      months.push(current.toLocaleString("en-US", { month: "long", year: "numeric" }));
      current.setMonth(current.getMonth() + 1);
    }
    return months;
  };

  useEffect(() => {
    if (props && props?.toGantt?.length > 0) {
      const taskItem = props?.toGantt?.filter((item) => {
        const projectManagerMatch = filterProjects?.PM ? item?.projectManager === filterProjects?.PM : true;
        const productionLocationNameMatch = filterProjects?.PL ? item?.productionLocation === filterProjects?.PL : true;
        const clientNameMatch = filterProjects?.CN ? item?.client_id?._id === filterProjects?.CN : true;
        const projectObjectNameMatch = filterProjects?.PO ? item?.projectObject === filterProjects?.PO : true;
        const projectName = item?.projectName?.toLowerCase()?.includes(searchText?.toLowerCase());
        const projectEndDateMatch = filterProjects?.YEAR ? item?.projectEndDate?.includes(filterProjects?.YEAR?.getFullYear()) : true;

        return projectManagerMatch && productionLocationNameMatch && projectObjectNameMatch && clientNameMatch && projectName && projectEndDateMatch
      })?.flatMap(item => ({
        projectName: item.projectName,
        list: item.taskHeader_id.map(taskHeader => {
          const subTasks = taskHeader.subTasks || [];
      
          return {
            headerTitle: taskHeader.headerTitle,
            subTasks: subTasks.map(subTask => ({
              subTaskName: subTask.subTaskName,
              startDate: subTask.startDate,
              endDate: subTask.endDate,
              subTaskStatus: subTask.subTaskStatus,
            })),
            startDate: subTasks.length 
              ? subTasks.reduce((minDate, subTask) => 
                  subTask.startDate && (!minDate || new Date(subTask.startDate) < new Date(minDate)) 
                    ? subTask.startDate 
                    : minDate, null) 
              : null,
            endDate: subTasks.length 
              ? subTasks.reduce((maxDate, subTask) => 
                  subTask.endDate && (!maxDate || new Date(subTask.endDate) > new Date(maxDate)) 
                    ? subTask.endDate 
                    : maxDate, null) 
              : null,
            status: subTasks.every(subTask => subTask.subTaskStatus === "Open")
              ? "Open"
              : subTasks.every(subTask => subTask.subTaskStatus === "Completed")
                ? "Completed"
                : "In-Progress",
          };
        }),
      }));

      // Collect all valid dates from the task items
      const allDates = taskItem.flatMap(project =>
        project.list.flatMap(task => task.startDate && task.endDate && [
          new Date(task.startDate),
          new Date(task.endDate)
        ]
        )).filter((item) => item);

      const minDate = new Date(Math.min(...allDates.map(date => date.getTime())));
      const maxDate = new Date(Math.max(...allDates.map(date => date.getTime())));

      const monthData = generateMonthData(minDate, maxDate);
      setMonthList(monthData);
      setTasks(taskItem);
    }
    
  }, [props, searchText]);

  const statusBodyTemplate = (status) => {
    let statusStyle;
    switch (status) {
      case "Completed":
        statusStyle = { background: '#26C10D' };
        break;
      case "In-Progress":
        statusStyle = { background: '#F3E900' };
        break;
      case "Open":
        statusStyle = { background: '#B5E0F8', border: 0 }
        break;
      default:
        statusStyle = { background: 'transparent' };
    }

    return <div style={statusStyle} className='h-full'>{""}</div>;
  };

  // Helper function to format date to "MMM YYYY"
  const formatDateToMonth = (date) => {
    return date ? new Date(date).toLocaleString("en-US", { month: "long", year: "numeric" }) : '';
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Completed":
        return { argb: "26C10D" }; // Green
      // case "In-Progress":
      //   return { argb: "F3E900" }; // Yellow
      case "Open":
        return { argb: "B5E0F8" }; // Red
      default:
        return { argb: "FFFFFF" }; // Transparent/White
    }
  };

  const handleDownloadGantt = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Gantt Chart");
  
    // Define column headers
    const headers = [
      { header: "Subtask Name", key: "subtaskName", width: 40 },
      { header: "Start Date", key: "startDate", width: 15 },
      { header: "End Date", key: "endDate", width: 15 },
      ...monthList.map((month) => ({ header: month, key: month, width: 15 })),
    ];
    worksheet.columns = headers;
  
    // Style header row
    const headerRow = worksheet.getRow(1);
    headerRow.font = { size: 12, bold: true };
    headerRow.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'D3D3D3' }, // Light grey
    };
  
    // Add project + subtask rows
    tasks.forEach((task) => {
      // Add project row
      const projectRowIndex = worksheet.lastRow ? worksheet.lastRow.number + 1 : 2;
      worksheet.addRow({ subtaskName: task.projectName });
      worksheet.mergeCells(`A${projectRowIndex}:E${projectRowIndex}`);
      const projectRow = worksheet.getRow(projectRowIndex);
      projectRow.getCell(1).font = { bold: true, size: 13 };
      projectRow.getCell(1).alignment = { vertical: "middle", horizontal: "left" };
  
      // Add each subtask
      task.list?.forEach((group) => {
        group.subTasks
          ?.filter((subTask) => ["Open", "Completed"].includes(subTask.subTaskStatus))
          .forEach((subTask) => {
            const row = worksheet.addRow({
              subtaskName: subTask.subTaskName,
              startDate: formatDateToMonth(subTask.startDate),
              endDate: formatDateToMonth(subTask.endDate),
            });
  
            // Colored left border based on status
            const borderColor =
              subTask.subTaskStatus === "Completed" ? "26C10D" :
              subTask.subTaskStatus === "Open" ? "B5E0F8" : "FFFFFF";
  
            row.getCell(1).border = {
              left: { style: "thick", color: { argb: borderColor } },
            };
  
            // Fill date range columns
            const startIndex = monthList.findIndex(
              (month) => month === formatDateToMonth(subTask.startDate)
            );
            const endIndex = monthList.findIndex(
              (month) => month === formatDateToMonth(subTask.endDate)
            );
  
            const monthStartIndex = 4; // Month columns start from column 4 (A=1, B=2, etc.)

            monthList.forEach((_, i) => {
              if (i >= startIndex && i <= endIndex) {
                const cell = row.getCell(monthStartIndex + i); // Correct offset
                cell.fill = {
                  type: "pattern",
                  pattern: "solid",
                  fgColor: getStatusColor(subTask.subTaskStatus),
                };
              }
            });
          });
      });
    });
  
    // Save the workbook
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    saveAs(blob, "GanttChart.xlsx");
  };
  

  const [selectedProject, setSelectedProject] = useState(null);
  return (
    <>
      <div className='gantt-sticky'>
        <div className='flex justify-content-between align-items-center'>
          <div className='task_progress mt-5'>Project Progress</div>
          <div className='flex gap-2 align-items-center'>
            <InputText value={searchText} type='search' onChange={(e) => setSearchText(e.target.value)} placeholder='Search by Project Name' />
            {/* <Button onClick={handleDownloadGantt} label='Download' className='btn-black' /> */}
          </div>
        </div>
        <hr className='hr-line'></hr>
        <div className='flex justify-content-end align-items-center pb-3'>
          <div className='monthly_delayed_open'></div><span className='status'>Open</span>
          {/* <div className='monthly_inprogress'></div><span className='status'>Inprogress</span> */}
          <div className='monthly_completed'></div><span className='status'>Completed</span>
        </div>
      </div>
      <div className="w-full overflow-auto gantt-table-wrapper" style={{ height: "calc(100vh - 270px)" }}>
      <table className="gantt-table">
        <thead className="gantt-table-sticky">
          <tr>
            <th className="h-full py-3 gt_task_name user-attachment gantt-project text-left" style={{ minWidth: "200px", zIndex: 4 }}>
              Project Name
            </th>
            <th className="h-full py-3 user-attachment gantt-start text-left" style={{ minWidth: "110px", zIndex: 4 }}>
              Start Date
            </th>
            <th className="h-full py-3 user-attachment gantt-end text-left" style={{ minWidth: "110px", zIndex: 4 }}>
              End Date
            </th>
            {monthList?.map((month, index) => {
               const parts = month.split(" ");
               const year = parts[1]; 
               return (
              <th key={index} className="h-full px-1 py-3 text-center user-attachment" style={{ borderRight: "1px solid #dfe1e5", minWidth: "80px"  }}>
                {month.slice(0, 3)} {year}
              </th>
              );
              })}
          </tr>
        </thead>
        <tbody>
  {tasks?.map((item, i) => {
    const isSelected = selectedProject === item.projectName;

    return (
      <React.Fragment key={i}>
        {/* Project Row */}
        <tr style={{ outline: "1px solid #EAEAEA", }}>
          <td
            className="tr-project-name block sticky left-0"
            onClick={() => setSelectedProject(isSelected ? null : item.projectName)}
            style={{ cursor: "pointer", color: isSelected ? "#03030A" : "#212121", border:'none' }}
          >
            {item.projectName}
          </td>
        </tr>

        {/* Show Subtasks Only When Project is Selected */}
        {isSelected &&
          item?.list?.flatMap((subItem) =>
            subItem.subTasks?.filter((subTask) => ["Open", "Completed"].includes(subTask.subTaskStatus))
          .map((subTask, idx) => {
              const startIndex = monthList.findIndex(
                (month) => month === formatDateToMonth(subTask.startDate)
              );
              const endIndex = monthList.findIndex(
                (month) => month === formatDateToMonth(subTask.endDate)
              );

              return (
                <tr key={`subtask-${idx}`} className="gantt-value" style={{ cursor: "auto", padding: 10, border: "1px solid #dfe1e5", height: "38.58px" }}>
                  {/* Subtask Name */}
                  <td style={{ maxWidth: "200px" }} className="gt_task_name file-upload-size gantt-project px-0 py-1">
                    <span
                      style={{
                        borderLeft: "6px solid",
                        borderLeftColor:
                          subTask.subTaskStatus === "Completed"
                            ? "#26C10D"
                            : subTask.subTaskStatus === "Open"
                            ? "#B5E0F8"
                            : "#FFFFF",
                        fontSize: "xx-large",
                        verticalAlign: "bottom",
                      }}
                      className="mr-1"
                    ></span>
                    {subTask.subTaskName}
                  </td>

                  {/* Subtask Start Date */}
                  <td style={{ maxWidth: "110px" }} className="gantt-start">
                    {formatDateToMonth(subTask.startDate)}
                  </td>

                  {/* Subtask End Date */}
                  <td style={{ maxWidth: "110px" }} className="gantt-end">
                    {formatDateToMonth(subTask.endDate)}
                  </td>

                  {/* Monthly Status Mapping */}
                  {monthList?.map((month, index) => (
                    <td
                      key={`${subTask.subTaskName}-${index}`}
                      className="month-cell p-0"
                      style={{
                        minWidth: "60px",
                        height: "38.58px",
                        background: index >= startIndex && index <= endIndex ? "#EAEAEA" : "transparent",
                        border: index >= startIndex && index <= endIndex ? 0 : "1px solid #EAEAEA",
                      }}
                    >
                      {index >= startIndex && index <= endIndex ? statusBodyTemplate(subTask.subTaskStatus) : ""}
                    </td>
                  ))}
                </tr>
              );
            })
          )}
      </React.Fragment>
    );
  })}
</tbody>
      </table>
    </div>
    </>
  );
}

export default GanttChart;





